import { Tag } from 'antd';
import React from 'react';
import reactStringReplace from 'react-string-replace';

const PLACEHOLDER_REGEX = /\$\$([a-zA-Z0-9_-]+)\$\$/g;

export function renderPlaceholderText(text: string | null | undefined) {
  let replaced;

  // 1. Sostituisce i caratteri di nuova riga con un <br />
  replaced = reactStringReplace(text ?? '', /(\n)/g, () => <br />);
  // 2. Sostituisce i placeholder con un Tag
  replaced = reactStringReplace(replaced, PLACEHOLDER_REGEX, match => (
    <Tag>{match}</Tag>
  ));

  return replaced;
}
